import { render, staticRenderFns } from "./RecoveryDownloadCard.vue?vue&type=template&id=3fb8edaa&"
import script from "./RecoveryDownloadCard.vue?vue&type=script&lang=ts&"
export * from "./RecoveryDownloadCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports